// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { iconUri } from '@nerdwallet/nw-client-lib/cdn';
import { Text, Heading } from '@nerdwallet/react-typography';
import parseMdLinks from '../../lib/parse-md-links';

const Step = ({ name, description, iconUri: uri }) => (
  <div className="step nw-row__col-3">
    <div
      className={(uri !== '' && 'step__content') || 'step__content--none'}
      style={{
        backgroundImage: uri && `url(${iconUri(uri)})`,
      }}
    >
      <Heading className="step__title" level={5}>
        {name}
      </Heading>
      <Text className="step__description" small>
        {parseMdLinks(description)}
      </Text>
    </div>
  </div>
);

Step.propTypes = {
  name: PropTypes.string,
  description: PropTypes.string,
  iconUri: PropTypes.string,
};

Step.defaultProps = {
  name: 'Step',
  description: 'This is such a great step!',
  iconUri: '',
};

export default Step;
